var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ItemSrcControl" }, [
    _c("div", [
      _c("input", {
        ref: "filename",
        staticClass: "ItemSrcControl_Url",
        attrs: { type: "text", readonly: "readonly" },
        domProps: { value: _vm.filenameWithCoordinates },
        on: {
          click: function($event) {
            _vm.onClickFilename()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "button",
        {
          staticClass: "ItemSrcControl_Button",
          on: { click: _vm.onClickCopy }
        },
        [_vm._v("\n      copy\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }